import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t("guides.title")}
          </h2>
          <p className="mt-3 text-foreground-600">{t("guides.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="aspect-[16/9] w-full overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={t(`articles.${article.slug}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                  <i className="ri-book-open-line w-4 h-4 flex items-center justify-center" />
                  {t(`articles.${article.slug}.tag`)}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {t(`articles.${article.slug}.title`)}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {t(`articles.${article.slug}.lead`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                  {t("guides.readMore")}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}